module.exports = __webpack_public_path__ + "static/img/mgh-logo-rgb.ca1b938.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mgh-logo-rgb.svg
// module id = wMIa
// module chunks = 1